import React from 'react';
import DashboardLayout from '../components/layout/DashboardLayout';
import PageHeader from '../components/layout/PageHeader';
import {Phone, Mail} from 'lucide-react';

const Support: React.FC = () => {
    return (
        <DashboardLayout>
            <PageHeader title="Support" subtitle="Got a question? We're here to help!" />

            <div className="space-y-6">
                <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-8">
                    <h3 className="text-xl font-semibold text-mld-text-primary mb-6">Support Options</h3>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                        <div>
                            <h4 className="text-lg font-semibold text-mld-text-primary mb-4">Call or Text</h4>
                            <a
                                href="tel:+18773557978"
                                className="flex items-center p-4 border border-gray-200 rounded-lg hover:shadow-md transition-shadow group">
                                <Phone className="h-8 w-8 text-mld-primary mr-4 group-hover:scale-110 transition-transform" />
                                <span className="text-mld-text-primary font-medium">(877) 355 - 7978</span>
                            </a>
                        </div>

                        <div>
                            <h4 className="text-lg font-semibold text-mld-text-primary mb-4">Email</h4>
                            <a
                                href="mailto:info@mylabsdirect.com"
                                className="flex items-center p-4 border border-gray-200 rounded-lg hover:shadow-md transition-shadow group">
                                <Mail className="h-8 w-8 text-mld-primary mr-4 group-hover:scale-110 transition-transform" />
                                <span className="text-mld-text-primary font-medium">info@mylabsdirect.com</span>
                            </a>
                        </div>
                    </div>
                </div>

                <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-8">
                    <h3 className="text-xl font-semibold text-mld-text-primary mb-4">Frequently Asked Questions</h3>
                    <p className="text-gray-600">
                        Visit our website for comprehensive FAQs, test information, and detailed instructions for your
                        lab tests.
                    </p>
                    <a
                        href="https://mylabsdirect.com/faq"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="inline-block mt-4 px-6 py-2 bg-mld-primary text-white rounded-lg hover:bg-mld-primary/90 transition-colors">
                        Visit FAQ Page
                    </a>
                </div>
            </div>
        </DashboardLayout>
    );
};

export default Support;
